var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgServicesNotFound = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 194,
    viewBox: "0 0 264 194",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6422_73874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.305 192.996V171.525C224.305 171.525 232.672 186.747 224.305 192.996Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.824 192.992L209.008 178.472C209.008 178.472 225.88 182.602 224.824 192.992Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2448 0H19.4148L0.5 32.7615L19.4148 65.5233H57.2448L76.1597 32.7615L57.2448 0Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5418 61.8459H55.1255L71.9173 32.7616L55.1255 3.67731H21.5418L4.75 32.7616L21.5418 61.8459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1353 25.6347C21.9909 25.6347 22.6846 24.9411 22.6846 24.0854C22.6846 23.2298 21.9909 22.5361 21.1353 22.5361C20.2796 22.5361 19.5859 23.2298 19.5859 24.0854C19.5859 24.9411 20.2796 25.6347 21.1353 25.6347Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1353 34.3109C21.9909 34.3109 22.6846 33.6173 22.6846 32.7616C22.6846 31.9059 21.9909 31.2123 21.1353 31.2123C20.2796 31.2123 19.5859 31.9059 19.5859 32.7616C19.5859 33.6173 20.2796 34.3109 21.1353 34.3109Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1353 42.9871C21.9909 42.9871 22.6846 42.2934 22.6846 41.4378C22.6846 40.5821 21.9909 39.8885 21.1353 39.8885C20.2796 39.8885 19.5859 40.5821 19.5859 41.4378C19.5859 42.2934 20.2796 42.9871 21.1353 42.9871Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0777 22.8459H27.6406V25.3249H57.0777V22.8459Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0777 31.5222H27.6406V34.0011H57.0777V31.5222Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0777 40.1983H27.6406V42.6772H57.0777V40.1983Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.589 0H206.759L187.844 32.7615L206.759 65.5233H244.589L263.503 32.7615L244.589 0Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.878 61.8459H242.461L259.253 32.7616L242.461 3.67731H208.878L192.086 32.7616L208.878 61.8459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.471 25.6347C209.327 25.6347 210.02 24.9411 210.02 24.0854C210.02 23.2298 209.327 22.5361 208.471 22.5361C207.616 22.5361 206.922 23.2298 206.922 24.0854C206.922 24.9411 207.616 25.6347 208.471 25.6347Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.471 34.3109C209.327 34.3109 210.02 33.6173 210.02 32.7616C210.02 31.9059 209.327 31.2123 208.471 31.2123C207.616 31.2123 206.922 31.9059 206.922 32.7616C206.922 33.6173 207.616 34.3109 208.471 34.3109Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.471 42.9871C209.327 42.9871 210.02 42.2934 210.02 41.4378C210.02 40.5821 209.327 39.8885 208.471 39.8885C207.616 39.8885 206.922 40.5821 206.922 41.4378C206.922 42.2934 207.616 42.9871 208.471 42.9871Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.414 22.8459H214.977V25.3249H244.414V22.8459Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.414 31.5222H214.977V34.0011H244.414V31.5222Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.414 40.1983H214.977V42.6772H244.414V40.1983Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.733 0.318176H113.27L94.5391 32.7615L113.27 65.2051H150.733L169.464 32.7615L150.733 0.318176Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.371 61.5634H148.628L165.257 32.7616L148.628 3.95978H115.371L98.7422 32.7616L115.371 61.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.972 25.704C115.819 25.704 116.506 25.017 116.506 24.1697C116.506 23.3223 115.819 22.6354 114.972 22.6354C114.124 22.6354 113.438 23.3223 113.438 24.1697C113.438 25.017 114.124 25.704 114.972 25.704Z",
    fill: "#0F438A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.972 34.2959C115.819 34.2959 116.506 33.609 116.506 32.7616C116.506 31.9142 115.819 31.2273 114.972 31.2273C114.124 31.2273 113.438 31.9142 113.438 32.7616C113.438 33.609 114.124 34.2959 114.972 34.2959Z",
    fill: "#0F438A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.972 42.8878C115.819 42.8878 116.506 42.2009 116.506 41.3535C116.506 40.5062 115.819 39.8192 114.972 39.8192C114.124 39.8192 113.438 40.5062 113.438 41.3535C113.438 42.2009 114.124 42.8878 114.972 42.8878Z",
    fill: "#0F438A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.565 22.9423H121.414V25.3971H150.565V22.9423Z",
    fill: "#0F438A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.565 31.5342H121.414V33.989H150.565V31.5342Z",
    fill: "#0F438A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.565 40.1261H121.414V42.5809H150.565V40.1261Z",
    fill: "#0F438A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.94 189.875L160.301 189.874L158.57 175.839L163.941 175.84L163.94 189.875Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.866 193.402L153.133 193.401V193.253C153.133 192.042 153.614 190.88 154.47 190.024C155.327 189.168 156.488 188.686 157.7 188.686L164.866 188.687L164.866 193.402Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.776 189.875L194.137 189.874L192.406 175.839L197.777 175.84L197.776 189.875Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.702 193.402L186.969 193.401V193.253C186.969 192.042 187.45 190.88 188.306 190.024C189.163 189.168 190.324 188.686 191.535 188.686L198.702 188.687L198.702 193.402Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.486 118.65C162.486 118.65 159.432 126.94 159.868 130.43C160.304 133.921 156.814 158.355 157.25 160.537C157.686 162.718 156.814 173.626 157.25 175.372C157.686 177.117 156.026 179.202 156.898 180.947C157.771 182.692 158.995 186.28 158.995 186.28L164.668 185.843L165.54 181.044C165.54 181.044 168.158 180.607 167.722 177.99C167.286 175.372 169.903 157.919 169.903 157.919L177.321 133.485L187.793 155.737C187.793 155.737 188.229 171.445 189.538 173.19C190.847 174.935 188.229 179.735 189.538 181.48C190.847 183.225 192.156 186.28 192.156 186.28H198.701V182.789C198.701 182.789 202.628 180.607 198.701 174.063L196.047 134.758L193.429 116.869L162.486 118.65Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.751 63.7866C183.252 63.7866 186.9 60.1379 186.9 55.6371C186.9 51.1363 183.252 47.4877 178.751 47.4877C174.25 47.4877 170.602 51.1363 170.602 55.6371C170.602 60.1379 174.25 63.7866 178.751 63.7866Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82 55.075C172.395 56.5442 172.97 58.0134 173.545 59.4826C174.252 61.2888 175.061 63.2212 176.718 64.2292C178.764 65.4737 181.497 64.8669 183.476 63.5187C185.256 62.3062 186.622 60.5779 187.392 58.5661C188.161 56.5543 188.296 54.3553 187.779 52.2644C187.262 50.1736 186.117 48.291 184.499 46.8696C182.881 45.4482 180.866 44.5561 178.726 44.313L178.644 45.7882L176.834 44.2708C176.7 44.5006 176.516 44.697 176.295 44.8453C176.075 44.9936 175.823 45.09 175.56 45.1273C175.297 45.1645 175.028 45.1416 174.775 45.0603C174.522 44.979 174.291 44.8413 174.098 44.6577C174.574 45.6434 174.025 46.8456 173.233 47.6007C172.259 48.5283 169.474 49.6432 169.589 51.3014C169.667 52.408 171.371 53.9282 171.82 55.075Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.184 130.705C201.465 130.286 201.65 129.81 201.728 129.312C201.805 128.813 201.772 128.304 201.631 127.819C201.49 127.335 201.244 126.887 200.912 126.508C200.579 126.129 200.167 125.827 199.705 125.624L199.868 117.741L195.102 116.473L195.028 127.61C194.739 128.408 194.752 129.285 195.066 130.074C195.38 130.864 195.972 131.51 196.731 131.892C197.49 132.273 198.363 132.363 199.183 132.144C200.004 131.926 200.716 131.413 201.184 130.705Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.805 68.8233C184.805 68.8233 178.49 65.6657 172.525 67.7707C166.561 69.8758 163.403 72.3317 163.403 72.3317L167.263 92.6805L162 120.046C162 120.046 189.015 117.941 191.471 120.046C193.927 122.151 193.927 117.59 193.927 117.59L191.821 91.6279L195.681 75.1384L184.805 68.8233Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.156 131.172C158.543 130.848 158.854 130.444 159.068 129.987C159.283 129.53 159.394 129.032 159.394 128.528C159.395 128.023 159.285 127.525 159.072 127.067C158.86 126.61 158.549 126.205 158.163 125.88L160.533 118.36L156.313 115.805L153.116 126.473C152.614 127.158 152.381 128.003 152.461 128.849C152.54 129.694 152.928 130.481 153.549 131.061C154.17 131.64 154.982 131.971 155.831 131.991C156.68 132.012 157.507 131.72 158.156 131.172Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.858 72.3317H163.402C163.402 72.3317 159.543 74.7876 159.543 78.296C159.543 81.8044 153.93 122.853 153.93 122.853L159.894 123.905L165.157 95.1364L169.016 87.4178L165.858 72.3317Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.016 75.1384H195.682C195.682 75.1384 197.787 77.2435 198.839 82.1553C199.892 87.067 200.944 106.363 200.944 106.363L200.243 123.905H194.98L194.278 101.101L190.77 86.3654L189.016 75.1384Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.378 193.628H126.297C126.218 193.628 126.143 193.597 126.087 193.541C126.031 193.485 126 193.41 126 193.331C126 193.252 126.031 193.177 126.087 193.121C126.143 193.066 126.218 193.034 126.297 193.034H239.378C239.457 193.034 239.532 193.066 239.588 193.121C239.644 193.177 239.675 193.252 239.675 193.331C239.675 193.41 239.644 193.485 239.588 193.541C239.532 193.597 239.457 193.628 239.378 193.628Z",
    fill: "#CBCBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6422_73874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 193.628,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServicesNotFound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/services-not-found.3d4f226d.svg";
export { ForwardRef as ReactComponent };